import React, { FC } from 'react';
import { useThemes } from '@hooks/useThemes';
import styles from './ScrollArea.module.css';

interface ScrollAreaProps {
    height: string;
    children: JSX.Element | JSX.Element[];
}

export const ScrollArea: FC<ScrollAreaProps> = ({ height, children }) => {
    const { useGrayscaleTheme } = useThemes();

    return (
        <div
            className={
                // theme
                `${useGrayscaleTheme ? styles['theme-grayscale'] : ''}` +
                // other classes
                ` ${styles['scroll-area-container']}`
            }
            style={{ maxHeight: height }}>
            {children}
        </div>
    );
};
